export default function TestimonialsSection() {
  const testimonials = [
    {
      name: '田中 一郎',
      location: '岡山市北区',
      project: '住宅外構工事',
      rating: 5,
      comment: '駐車場の舗装工事をお願いしました。丁寧な説明と確実な施工で、仕上がりも大変満足しています。アフターサービスも充実していて安心です。',
      image: 'https://public.readdy.ai/ai/img_res/6d4d9cc152cc0c9c32bfad32887fb4ec.jpg'
    },
    {
      name: '佐藤 美智子',
      location: '倉敷市',
      project: '水道管修繕工事',
      rating: 5,
      comment: '水道管の緊急修理でお世話になりました。迅速な対応と丁寧な作業で、とても助かりました。料金も明確で信頼できる会社です。',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20female%20homeowner%20in%20her%2040s%2C%20satisfied%20customer%20portrait%2C%20residential%20background%2C%20natural%20lighting%2C%20genuine%20smile%2C%20professional%20photography%20style%2C%20high%20quality%20portrait&width=80&height=80&seq=customer2&orientation=squarish'
    },
    {
      name: '山田 建設株式会社',
      location: '岡山市南区',
      project: '造成工事',
      rating: 5,
      comment: '大規模な造成工事を依頼しました。工期通りの完成で品質も申し分ありません。現場管理も徹底されており、今後もお付き合いしたい会社です。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20male%20business%20owner%20in%20his%2040s%2C%20construction%20company%20representative%2C%20business%20suit%2C%20confident%20appearance%2C%20office%20background%2C%20natural%20lighting%2C%20professional%20portrait&width=80&height=80&seq=customer3&orientation=squarish'
    },
    {
      name: '鈴木 和子',
      location: '岡山市東区',
      project: '道路舗装工事',
      rating: 5,
      comment: '自宅前の道路舗装でお世話になりました。近隣への配慮も行き届いており、工事中も安心して過ごせました。仕上がりも美しく満足しています。',
      image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20female%20homeowner%20in%20her%2060s%2C%20satisfied%20customer%20portrait%2C%20residential%20background%2C%20natural%20lighting%2C%20genuine%20smile%2C%20professional%20photography%20style%2C%20high%20quality%20portrait&width=80&height=80&seq=customer4&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>お客様の声</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            おかやま土木工事株式会社をご利用いただいたお客様から、
            たくさんの嬉しいお声をいただいております。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className="flex items-start mb-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900">{testimonial.name}</h3>
                  <p className="text-sm text-gray-500">{testimonial.location}</p>
                  <p className="text-sm text-blue-600 font-medium">{testimonial.project}</p>
                </div>
                <div className="flex text-yellow-400">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
              </div>
              <blockquote className="text-gray-700 leading-relaxed">
                "{testimonial.comment}"
              </blockquote>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-white rounded-lg shadow-md p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">お客様満足度</h3>
            <div className="text-6xl font-bold text-blue-600 mb-2">98%</div>
            <p className="text-gray-600">
              2023年度お客様アンケート結果<br />
              （回答数：156件）
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}